import type { PageUrl } from "@octopusdeploy/portal-routes";
import type { History } from "history";
export function isPageUrl(to: History.LocationDescriptor | PageUrl): to is PageUrl {
    return typeof to === "object" && "resolveWithSpaceId" in to;
}
